/* eslint-disable react/prop-types */
import React from 'react';
import numeral from 'numeral';
import { Link } from 'react-router-dom';

export const defaultSorts = ['viewShare'];
export const affinityDefaultSorts = ['affinityIndex'];

const SHOW_CONTENT_TYPE = 'series';
const MOVIE_CONTENT_TYPE = 'movie';
const SHOW_CONTENT_TYPE_LABEL = 'Show';
const MOVIE_CONTENT_TYPE_LABEL = 'Movie';

const renderContentTypeCell = value => {
  let contentType = '';
  if (value === SHOW_CONTENT_TYPE) {
    contentType = SHOW_CONTENT_TYPE_LABEL;
  } else if (value === MOVIE_CONTENT_TYPE) {
    contentType = MOVIE_CONTENT_TYPE_LABEL;
  }
  return contentType;
};

const renderTitleCell = (original = {}, value = '') => {
  const { networkName, studioName, contentId } = original;
  let title = '';
  if (networkName) {
    title = <Link to={`/show/${contentId}`}>{value}</Link>;
  } else if (studioName) {
    title = <Link to={`/movie/${contentId}`}>{value}</Link>;
  } else {
    title = value;
  }
  return title;
};

const renderNetworkStudioCell = (original = {}) => {
  const { networkName, networkId, studioName } = original;
  let name = '';
  if (networkName) {
    name = networkId ? (
      <Link to={`/network/${networkId}`}>{networkName}</Link>
    ) : (
      networkName
    );
  }
  if (studioName) {
    name = name.length > 0 ? `${name} / ${studioName}` : studioName;
  }
  return name;
};

export const topShowsColumns = [
  {
    Header: 'Title',
    accessor: 'title',
    className: 'tvt-tabular-data-table__actor-top-titles',
    Cell: ({ row: { original }, cell: { value } }) =>
      renderTitleCell(original, value)
  },
  {
    Header: 'Content Type',
    accessor: 'contentType',
    className: 'tvt-tabular-data-table__actor-top-content-type caret-center',
    Cell: ({ cell: { value } }) => renderContentTypeCell(value)
  },
  {
    Header: 'Network / Studio',
    accessor: 'networkName',
    className:
      'tvt-tabular-data-table__actor-top-titles-network-studio caret-center',
    Cell: ({ row: { original } }) => renderNetworkStudioCell(original)
  },
  {
    Header: 'Share of Views',
    accessor: 'viewShare',
    Cell: ({ cell: { value } }) => `${numeral(value).format('0.00')}%`,
    className:
      'tvt-tabular-data-table__td-kpi tvt-tabular-data-table__actor-top-titles-viewShareScore caret-center',
    sortDescFirst: true
  }
];

export const affinityColumns = [
  {
    Header: 'Title',
    accessor: 'title',
    className: 'tvt-tabular-data-table__actor-affinity-title',
    Cell: ({ row: { original }, cell: { value } }) =>
      renderTitleCell(original, value)
  },
  {
    Header: 'Content Type',
    accessor: 'contentType',
    className:
      'tvt-tabular-data-table__actor-affinity-content-type caret-center',
    Cell: ({ cell: { value } }) => renderContentTypeCell(value)
  },
  {
    Header: 'Network / Studio',
    accessor: 'networkName',
    className:
      'tvt-tabular-data-table__actor-affinity-network-studio caret-center',
    Cell: ({ row: { original } }) => renderNetworkStudioCell(original)
  },
  {
    Header: 'Affinity Index',
    accessor: 'affinityIndex',
    Cell: ({ cell: { value } }) => `${numeral(value).format('0,0')}`,
    className:
      'tvt-tabular-data-table__td-kpi tvt-tabular-data-table__actor-affinity-affinityIndex caret-center',
    sortDescFirst: true
  }
];

export const formatGenderDemo = ({ data, loading }) => {
  if (loading) {
    return [];
  }

  return data.map(g => {
    const { gender, index, viewers } = g;
    const viewerIndex = numeral(index * 100).format('0.0');
    return {
      id: gender,
      viewers,
      label: (
        <tspan>
          <tspan className="user-demo-tspan__gender-gender">{gender}</tspan>
          <tspan className="user-demo-tspan__gender-viewerIndex" x={80}>
            {`${viewerIndex}%`}
          </tspan>
        </tspan>
      ),
      value: viewerIndex
    };
  });
};

export default {
  topShowsColumns,
  affinityColumns,
  affinityDefaultSorts,
  defaultSorts,
  formatGenderDemo
};
